Apt.fn.extend('properties', {
	/**
	 * Display mobile map view
	 *
	 * @param {Boolean} [skip=false]
	 */
	showMap(skip) {
		const priv = this.$private;

		$$('propertiesLeft')[0].classList.add('-is-active');

		LS.util.crop();

		document.body.classList.add('-is-mapped');

		if (priv.map) {
			priv.map.resize();
		} else if (! priv.map && ! skip) {
			priv.loadMap();
		}
	},

	/**
	 * Display mobile list view
	 */
	showList() {
		$$('propertiesLeft').removeClass('-is-active');

		LS.util.uncrop();

		document.body.classList.remove('-is-mapped');

		$(window).trigger('scroll');
	}
}, {
	/**
	 * Initialize responsive breakpoint logic
	 *
	 * @param {Function} [fn]
	 */
	initMobile(fn) {
		const scope = this;
		const left = $$('propertiesLeft')[0];

		$.screen.map([
			{
				max: 3,
				once: true,
				callback: () => {
					scope.initOptions();
				}
			},
			{
				max: 3,
				init: false,
				callback: () => {
					$(window).off('resize.properties');

					left.removeAttribute('style');
				}
			},
			{
				max: 4,
				callback: () => {
					scope.initSticky();
				}
			},
			{
				max: 4,
				init: false,
				callback: () => {
					$$('propertiesFilters').prependTo('$propertiesRight');
				}
			},
			{
				min: 4,
				callback: () => {
					$(window).on('resize', () => {
						left.style.height = (window.innerHeight - 70) + 'px';
					}, {
						init: true,
						namespace: 'properties'
					});
				}
			},
			{
				min: 4,
				init: false,
				callback: conf => {
					if (conf.prev < 4) {
						scope.$public.showList();
					}
				}
			},
			{
				min: 4,
				once: true,
				callback: () => {
					if (fn) {
						fn();
					}
				}
			},
			{
				min: 5,
				callback: () => {
					$$('propertiesFilters').appendTo('$propertiesFiltersDesktop');
				}
			}
		], {
			namespace: 'properties'
		});
	},

	/**
	 * Initialize stickiness
	 */
	initSticky() {
		const filters = $$('propertiesFilters')[0];
		const hiddenClass = '-is-hidden';

		let prev = 0;
		let lower = 0;
		let upper = 0;
		let sticky = true;
		let top;

		if (! filters) {
			return;
		}

		$(window).on('scroll', () => {
			top = window.scrollY;

			if (! top && LS.state.cropped) {
				return;
			}

			if (! top || top < upper - 100) {
				if (! sticky) {
					sticky = true;

					filters.classList.remove(hiddenClass);
				}
			} else if (sticky && top > lower + 100) {
				sticky = false;

				filters.classList.add(hiddenClass);
			}

			if (top > prev) {
				upper = top;
			} else {
				lower = top;
			}

			prev = top;
		}, {
			init: true,
			namespace: 'properties'
		});
	},

	/**
	 * Initialize mobile options
	 */
	initOptions() {
		const scope = this;

		scope.activeView = 'list';

		$$('propertiesToggle').on('mousedown', (e, el) => {
			scope.activeView = el.dataset.view;

			scope.activeView === 'map' ?
				scope.$public.showMap() :
				scope.$public.showList();
		}, {
			namespace: 'properties'
		});

		const options = $$('propertiesOptions')[0];

		if (! options) {
			return;
		}

		const hiddenClass = '-is-hidden';

		$.scroll.map([
			{
				callback: () => {
					options.classList.remove(hiddenClass);
				}
			},
			{
				threshold: -1,
				callback: () => {
					options.classList.add(hiddenClass);
				}
			}
		], {
			namespace: 'properties',
			target: $$('results')
		});
	}
});